<template>
  <div>
    <MenuApp></MenuApp>
    <div class="container">
      <div class="message">Imprimer plus rapidement avec PrintStation</div>
      <p>Imprimer rapidement, facilement depuis nos stations d'impression.</p>

      <div class="steps-container">
        <div class="step-card">
          <div class="step-header">
            <h2 class="step-title">Étape 1 : Choisissez votre imprimante</h2>
          </div>
          <div class="step-content">
            <div class="printer-selection">
              <select id="printer" v-model="selectedPrinterId">
                <option
                  v-for="printer in printers"
                  :key="printer.id"
                  :value="printer.id"
                >
                  {{ printer.adresse }}
                </option>
              </select>

              <div v-if="selectedPrinterId">
                Vous avez sélectionné l'imprimante :
                {{ selectedPrinterAddress }}
                <div class="info-icon-container">
                  <span class="info-icon">i</span>
                  <div class="tooltip">
                    <p class="price">
                      Prix NB (1ère page) : {{ PRICE_FIRST_PAGE_BW }}€<br />
                      Suivante : {{ PRICE_BW }}€
                    </p>
                    <p class="price">
                      Prix Couleur (1ère page) : {{ PRICE_FIRST_PAGE_COLOR }}€
                      Suivante : {{ PRICE_COLOR }}€
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selectedPrinterId" class="step-card">
          <div class="step-header">
            <h2 class="step-title">Étape 2 : Upload un fichier PDF</h2>
          </div>
          <div class="step-content">
            <div class="file-upload">
              <input
                type="file"
                id="file"
                class="file-input"
                @change="onFileSelected"
              />
              <label for="file" class="button">Upload</label>
            </div>

            <p v-if="error" class="error-message">{{ error }}</p>
            <p v-if="uploading" class="uploading">Uploading...</p>
            <div v-if="fileDetails">
              <p>
                <br />
                <strong v-if="fileDetails.fileName">{{
                  fileDetails.fileName
                }}</strong>
                <br />
                ( {{ fileDetails.pages }} pages,
                {{ (fileDetails.size / (1024 * 1024)).toFixed(2) }} MB )
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="fileDetails && selectedPrinterId">
        <div class="steps-container">
          <div class="step-card">
            <div class="step-header">
              <h2 class="step-title">Étape 3 : Choix des options & Paiement</h2>
            </div>
            <div class="step-content">
              <SelectOptions
                v-if="fileDetails"
                :fileDetails="fileDetails"
                :selectedPrinter="selectedPrinterId"
                @proceedToPayment="handleProceedToPayment"
                @update-fileDetails="updateFileDetails"
              />
              <PaymentStep v-if="fileDetails" :fileDetails="fileDetails" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import SelectOptions from "./SelectOptions.vue";
import PaymentStep from "./PaymentStep.vue";
import MenuApp from "./MenuApp.vue";

export default {
  components: {
    SelectOptions,
    PaymentStep,
    MenuApp,
  },
  data() {
    return {
      error: null,
      uploading: false,
      fileDetails: null,
      printers: [], // Liste des imprimantes
      selectedPrinterId: null, // ID de l'imprimante sélectionnée
      PRICE_BW: process.env.VUE_APP_PRICE_BW,
      PRICE_COLOR: process.env.VUE_APP_PRICE_COLOR,
      PRICE_FIRST_PAGE_BW: process.env.VUE_APP_PRICE_FIRST_PAGE_BW,
      PRICE_FIRST_PAGE_COLOR: process.env.VUE_APP_PRICE_FIRST_PAGE_COLOR,
    };
  },
  computed: {
    selectedPrinterAddress() {
      const selectedPrinter = this.printers.find(
        (printer) => printer.id === this.selectedPrinterId
      );
      return selectedPrinter ? selectedPrinter.adresse : "Non sélectionnée";
    },
  },
  methods: {
    async fetchPrinters() {
      try {
        const response = await axios.get(process.env.VUE_APP_URL_GET_PRINTERS);
        this.printers = response.data;

        // Sélection automatique de l'imprimante depuis l'URL
        const printerIdFromUrl = this.getPrinterIdFromUrl();
        if (printerIdFromUrl) {
          const exists = this.printers.some(
            (printer) => printer.id === printerIdFromUrl
          );
          if (exists) {
            this.selectedPrinterId = printerIdFromUrl;
          }
        }
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des imprimantes :",
          error
        );
        this.error = "Impossible de récupérer les imprimantes disponibles.";
      }
    },
    getPrinterIdFromUrl() {
      const path = window.location.pathname; // Exemple : "/1"
      const segments = path.split("/"); // Diviser l'URL en segments
      const id = parseInt(segments[1], 10); // Extraire et convertir en nombre
      return isNaN(id) ? null : id; // Retourner l'ID ou null si invalide
    },
    async onFileSelected(event) {
      const file = event.target.files[0];
      this.error = null;
      this.uploading = true;

      if (!file) {
        this.error = "Veuillez sélectionner un fichier.";
        this.uploading = false;
        return;
      }
      if (file && file.type !== "application/pdf") {
        this.error = "Veuillez sélectionner un fichier PDF.";
        event.target.value = "";
        this.uploading = false;
        return;
      }

      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await axios.post(
          process.env.VUE_APP_URL_UPLOAD,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.fileDetails = response.data;
      } catch (err) {
        this.error =
          err.response?.data?.error || "Erreur lors du téléchargement.";
      } finally {
        this.uploading = false;
      }
    },
    handleProceedToPayment(paymentDetails) {
      console.log("Payment Details:", paymentDetails);
    },
    updateFileDetails(newDetails) {
      this.fileDetails = { ...this.fileDetails, ...newDetails };
    },
  },
  mounted() {
    this.fetchPrinters(); // Récupérer les imprimantes au montage
  },
};
</script>
